import { QueryToken } from "./QueryToken.js";

export class GroupByKeyToken extends QueryToken {

    private readonly _fieldName: string;
    private readonly _projectedName: string;

    private constructor(fieldName: string, projectedName: string) {
        super();
        this._fieldName = fieldName;
        this._projectedName = projectedName;
    }

    public static create(fieldName: string, projectedName: string): GroupByKeyToken {
        return new GroupByKeyToken(fieldName, projectedName);
    }

    public writeTo(writer): void {
        QueryToken.writeField(writer, this._fieldName || "key()");

        if (!this._projectedName || this._projectedName === this._fieldName) {
            return;
        }

        writer
            .append(" as '")
            .append(this._projectedName)
            .append("'");
    }
}
